export default function PartnershipHeroSection() {
  return (
    <section className="relative min-h-[85vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/81a3db46d50b00c604c4c4926d7f8a05.jpg"
          alt="Partnership"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>
      
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 text-center text-white">
        <h1 className="text-6xl md:text-7xl font-bold mb-8 tracking-tight">
          Work with Daygreen
        </h1>
        <p className="text-xl md:text-2xl font-light max-w-3xl mx-auto leading-relaxed">
          지속가능한 미래를 함께 만들어갈<br />
          파트너를 기다립니다
        </p>
      </div>
    </section>
  );
}